var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormHelperText, styled } from '@mui/material';
import React, { forwardRef } from 'react';
import { LabelPlacement } from '../Form/FormInputProps';
import InputLabel from '../InputLabel';
import MenuItem from '../MenuItem';
import Select from '../Select';
import SFormControl from '../SFormControl';
var Input = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
});
var SelectFormInput = forwardRef(function (_a, ref) {
    var _b = _a.boldLabel, boldLabel = _b === void 0 ? false : _b, children = _a.children, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.defaultValue, defaultValue = _d === void 0 ? '' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.displayEmpty, displayEmpty = _f === void 0 ? true : _f, errorMessage = _a.errorMessage, hintMessage = _a.hintMessage, _g = _a.insets, insets = _g === void 0 ? false : _g, label = _a.label, _h = _a.labelPlacement, labelPlacement = _h === void 0 ? LabelPlacement.TOP : _h, _j = _a.multiple, multiple = _j === void 0 ? false : _j, optional = _a.optional, _k = _a.placeholderText, placeholderText = _k === void 0 ? '' : _k, _l = _a.required, required = _l === void 0 ? false : _l, _m = _a.size, size = _m === void 0 ? 'medium' : _m, sx = _a.sx, props = __rest(_a, ["boldLabel", "children", "color", "defaultValue", "disabled", "displayEmpty", "errorMessage", "hintMessage", "insets", "label", "labelPlacement", "multiple", "optional", "placeholderText", "required", "size", "sx"]);
    var error = !!errorMessage;
    var helperText = errorMessage || hintMessage;
    return (React.createElement(SFormControl, __assign({}, { error: error, required: required, labelPlacement: labelPlacement, insets: insets }),
        label && (React.createElement(InputLabel, __assign({}, { boldLabel: boldLabel, optional: optional, labelPlacement: labelPlacement, required: required }), label)),
        React.createElement(Input, null,
            React.createElement(Select, __assign({ inputProps: { 'aria-label': label || 'select-without-label' } }, {
                color: color,
                defaultValue: defaultValue,
                disabled: disabled,
                displayEmpty: displayEmpty,
                error: error,
                multiple: multiple,
                ref: ref,
                size: size,
                sx: sx,
            }, props),
                displayEmpty && !multiple && (React.createElement(MenuItem, { value: "", color: "hint" },
                    React.createElement("i", null, placeholderText))),
                children),
            helperText && React.createElement(FormHelperText, null, helperText))));
});
SelectFormInput.displayName = 'SelectFormInput';
export default SelectFormInput;
